import React from 'react'
import {Icon} from '@chakra-ui/react'

const ChevronDown = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props} data-testid="chevron-down" aria-hidden="true">
            <path
                id="arrow"
                d="M11.71 14.21L4.41 7L3 8.4L11.71 17L20.41 8.4L19 7L11.71 14.21Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ChevronDown
